import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Wed Sep 26 2018
 * @author PKl
 * @author SKu
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { action, observable, runInAction } from 'mobx';
import { CompetitorsPriorityLayer } from '../../transportLayers/site/CompetitorsPriorityLayer';
import { BaseStore } from '../BaseStore';
import { StoreName } from '../StoreName';
/**
 * This store obtaining data of Competitor Priorities.
 */

export var CompetitorsPriorityStore =
/*#__PURE__*/
function (_BaseStore) {
  _inherits(CompetitorsPriorityStore, _BaseStore);

  function CompetitorsPriorityStore() {
    var _this;

    _classCallCheck(this, CompetitorsPriorityStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CompetitorsPriorityStore).apply(this, arguments));
    /** Store name */

    _this.name = StoreName.CompetitorsPriority;
    /** layer contains methods for fletching data */

    _this.competitorsPriorityLayer = new CompetitorsPriorityLayer();
    /** List of Priorities */

    _this.priorities = new Map();
    /** List of Competitors */

    _this.competitors = new Map();
    /** Fletches all priorities for the page */

    _this.getAllPriorities = function () {
      return _this.competitorsPriorityLayer.findAll().then(function (priorities) {
        runInAction(function () {
          priorities.forEach(function (priority) {
            _this.priorities = _this.priorities.set(priority.id, priority);
          });
        });
      });
    };
    /** Fletches all competitors for the page */


    _this.getAllCompetitors = function () {
      return _this.competitorsPriorityLayer.findAllCompetitors().then(function (competitors) {
        runInAction(function () {
          competitors.forEach(function (competitor) {
            _this.competitors = _this.competitors.set(competitor.id, competitor);
          });
        });
      });
    };

    return _this;
  }
  /**
   * Method create new priority
   * @param newCompetitorsPriority -  new priority that you want to create
   */


  _createClass(CompetitorsPriorityStore, [{
    key: "create",
    value: function create(newCompetitorsPriority) {
      var _this2 = this;

      return this.competitorsPriorityLayer.create(newCompetitorsPriority).then(function (competitorsPriority) {
        if (competitorsPriority.id) {
          runInAction(function () {
            return _this2.priorities = _this2.priorities.set(competitorsPriority.id, competitorsPriority);
          });
        }
      });
    }
    /**
     * Method updates tier using tierLayer.
     * @param newCompetitorsPriority -  priority that you want to update
     */

  }, {
    key: "update",
    value: function update(newCompetitorsPriority) {
      var _this3 = this;

      return this.competitorsPriorityLayer.update(newCompetitorsPriority).then(function (competitorsPriority) {
        if (competitorsPriority.id) {
          runInAction(function () {
            return _this3.priorities = _this3.priorities.set(competitorsPriority.id, competitorsPriority);
          });
        }
      });
    }
    /**
     * Method deletes existing priority
     * @param id -  id of the tierm that you want to delete.
     */

  }, {
    key: "delete",
    value: function _delete(id) {
      var _this4 = this;

      return this.competitorsPriorityLayer.delete(id).then(function (deleted) {
        if (deleted) {
          runInAction(function () {
            return _this4.priorities.delete(id);
          });
        }
      });
    }
  }]);

  return CompetitorsPriorityStore;
}(BaseStore);

__decorate([observable, __metadata("design:type", Map)], CompetitorsPriorityStore.prototype, "priorities", void 0);

__decorate([observable, __metadata("design:type", Map)], CompetitorsPriorityStore.prototype, "competitors", void 0);

__decorate([action, __metadata("design:type", Object)], CompetitorsPriorityStore.prototype, "getAllPriorities", void 0);

__decorate([action, __metadata("design:type", Object)], CompetitorsPriorityStore.prototype, "getAllCompetitors", void 0);